import { useSearchParams } from "react-router-dom";

/** Hub tab stored in `?tab=`; unknown values fall back to the first key. */
export function useSectionParam(keys) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const section = keys.includes(tab) ? tab : keys[0];
  const setSection = (key) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", key);
    next.delete("date");
    setSearchParams(next, { replace: true });
  };
  return [section, setSection];
}
